import React, { memo, useCallback, useEffect, useRef, useState } from "react";
import styles from "./index.module.less";
import cx from "classnames";
import { Affix } from "antd";

export interface IProps {
  askSource: string;
  data: any[];
}
let TIMEOUT_CLEAR: any = null;
const RelevantKinds: React.FC<IProps> = ({ data, askSource }) => {
  const targetRef = useRef<HTMLDivElement>(null);
  const itemRef = useRef<HTMLDivElement>(null);
  const [left, setLeft] = useState<boolean>(true);
  const [right, setRight] = useState<boolean>(true);
  const [scrollLock, setScrollLock] = useState<boolean>(false);
  const itemWidth = itemRef.current?.offsetWidth || 0;

  const scrollTo = useCallback((scrollValue) => {
    let scrollLeft = targetRef.current!.scrollLeft;
    targetRef.current!.scrollTo(scrollLeft + scrollValue, 0);
  }, []);

  useEffect(() => {
    if (!!data.length && data.length > 1) {
      setLeft(false);
      setRight(false);
    }
  }, [data]);

  if (data.length === 0) {
    return null;
  }

  return (
    <Affix offsetTop={10}>
      <div id='RelevantKind' className={cx(styles["relevant-kind"], "w-full m-auto mb-40 relative")}>
        <h2 className='text-24 p-14 mb-0 pb-2 bg-[#fff] border-1 border-solid border-[#E8E8E8] border-b-0'>相關車款</h2>
        <div className='flex justify-center items-center bg-[#fff] border-1 border-solid border-[#E8E8E8] border-t-0 relative'>
          {!left && (
            <i
              className={styles["left-icon"]}
              onClick={(e) => {
                e.stopPropagation();
                if (scrollLock) return;
                setScrollLock(true);
                scrollTo(-itemWidth);
                TIMEOUT_CLEAR = setTimeout(() => {
                  setScrollLock(false);
                  TIMEOUT_CLEAR = null;
                }, 500);
              }}
            />
          )}
          {!right && (
            <i
              className={styles["right-icon"]}
              onClick={(e) => {
                e.stopPropagation();
                if (scrollLock) return;
                setScrollLock(true);
                scrollTo(itemWidth);
                TIMEOUT_CLEAR = setTimeout(() => {
                  setScrollLock(false);
                  TIMEOUT_CLEAR = null;
                }, 500);
              }}
            />
          )}

          <div className={styles["brand-scroll"]} ref={targetRef}>
            {Array.isArray(data) &&
              data.map((v: any, i) => (
                <div className='flex justify-center flex-col items-center w-full px-14' key={i} ref={itemRef}>
                  <a
                    href={`/photoModel-info.html?k=${v.kindId}`}
                    className='CarItemPicture flex flex-col justify-center items-center w-full'
                  >
                    <img className='w-200 h-134' src={v.thumb} alt='' />
                    <div className='line-clamp-1 mt-16 text-[#333333] text-20 font-bold w-276 text-center pb-4'>
                      {v.brandName}
                    </div>
                    <div className='mb-6 line-clamp-1 text-[#333333] text-20 font-bold w-276 text-center pb-4'>
                      {v.kindName}
                    </div>
                    <div className='flex justify-between mb-18 flex-col items-center'>
                      <span className='text-[#333333] text-16'>{v.price}</span>
                      {v.discountPriceForInt > 0 && (
                        <span className='text-16 text-[#FF4333]'>最高優惠禮包{v.discountPriceForInt}</span>
                      )}
                    </div>
                  </a>

                  <div className='flex justify-between mb-18 gap-12'>
                    <a
                      href={`/photoModel-balance.html?k=${v.kindId}`}
                      className='SpecEquip text-[#FFFFFF] text-18 bg-[#3264FF] rounded-6 py-8 px-16'
                    >
                      規格配備
                    </a>
                    {!!v.isInquiry && (
                      <a
                        href={`/ask/price?b=${v.brandId}&k=${v.kindId}&source=${askSource}}`}
                        className='RelevantInquiry text-[#FFFFFF] text-18 bg-[#FF4333] rounded-6 py-8 px-16'
                      >
                        領取優惠
                      </a>
                    )}
                  </div>
                </div>
              ))}
          </div>
        </div>
      </div>
    </Affix>
  );
};

export default memo(RelevantKinds);
